export default __webpack_public_path__ + "static/media/no-minigoal.cea8a0c4.png";